<template>
  <div class="breaking_news">
      <!-- 左边新闻内容 -->
      <div class="news_left" ref="newScroll">
          <div class="news_list" v-for="(year,index1) in news" :key="index1" >
              <div class="year_list" :class="{timeActive:index1 === num-1}">{{ year.year }}年</div>
              <ul v-for="(month,index) in year.month_list" :key="index" class="month_list">
                  <!-- 月份 -->
                  <li class="month_item" :class="{timeActive:index1 === num-1}">{{ month.month }}</li>
                  <!-- 新闻 -->
                  <li class="content_item" :class="{contentActive:index1 === num-1}">{{ month.content }}</li>
              </ul>
          </div>
      </div>
      <!-- 右边年份 -->
      <div class="news_right" ref="timeScroll">
          <div class="right_title">时间排序</div>
          <div class="right_content">
              <ul v-for="(item,index) in news" :key="index">
                  <li 
                  class="year" 
                  @click="selectYear(index)"
                  :class="{yearActive:index === num-1}"
                  >
                      {{ item.year }}
                  </li>
              </ul>
          </div>
      </div>
  </div>
</template>

<script>
import newsData from '../news.json';
export default {
    data(){
        return{
            news:[],               // 事件数据列表
            listHeight:[],         // 年份高度
            num:0,                 // 匹配下标
            currentItemHeight:'',  // 当前元素高度
            scrollY:''             // 滚动高度
        }
    },
    created(){
        // 获取新闻数据
        this.getnewsData()
    },
    mounted(){
        // 计算年份区间高度
        this.calculateHeight()
        // 监听滚动
        window.addEventListener('scroll', this.handleScroll, true)
    },
    methods:{
        // 获取数据
        getnewsData(){
            console.log(newsData.list)
            this.news = newsData.list
        },
        // 计算年份区间高度
        calculateHeight(){
            // 获取每个年份元素
            let newsList = this.$refs.newScroll.getElementsByClassName('news_list');
            console.log(newsList);
            let height = 0;
            this.listHeight.push(height)
            // 遍历获取的每个年份
            for(let i = 0;i < newsList.length;i++){
                let item = newsList[i];   // 获取每个年份高度
                console.log(item.offsetHeight)
                height += item.offsetHeight  
                this.listHeight.push(height)  // 每个年份的累加高度
            }
            console.log(this.listHeight)
        },
        // 监听页面滚动高度
        handleScroll(){
            let top = Math.floor(this.$refs.newScroll.scrollTop)
            // console.log(top)
            this.scrollY = top
            this.currentIndex()
        },
        // 页面滚动到的当前下标
        currentIndex(){
            for(let i = 0;i<this.listHeight.length;i++){
                let height1 = this.listHeight[i]
                // console.log(height1)
                if(this.scrollY < height1){
                    console.log(i)
                    this.num = i;
                    return;
                }
            }
        },
        // 选择年份
        selectYear(index){
            console.log(index)
            let newsList = this.$refs.newScroll.getElementsByClassName('news_list');
            // console.log(newsList)
            // 获取每个年份元素
            let item = newsList[index]
            // 第一个年份高度
            let firtItemHight = newsList[0].offsetTop
            console.log(item)
            // 当前元素高度
            this.currentItemHeight = item.offsetTop
            // this.newScroll.scrollToElement(item,250)
            console.log(firtItemHight)
            this.$refs.newScroll.scrollTop = this.currentItemHeight-firtItemHight;
            console.log(this.$refs.newScroll.scrollTop)
            // this.number = index
            // return index
        },
    }
}
</script>

<style lang="scss">
.breaking_news{
    width: 1060px;
    margin: 0 auto;
    padding: 25px 0 45px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .news_left{ 
        width: 900px;
        height: 880px;
        overflow: auto;
        .news_list{
            border-bottom: 1px solid rgba(238,238,238,1);
            width: 750px;
            margin-top: 20px;
            .year_list{
                font-size:14px;
                color:rgba(102,102,102,1);
                line-height: 40px;
            }
            .timeActive{
                font-size:14px;
                font-weight:bold;
                color:#333333;
            }
            .month_list{
                display: flex;
                margin-bottom: 25px;
                .month_item{
                    width: 68px;
                    font-size:14px;
                    color:rgba(102,102,102,1);
                    line-height: 25px;
                    // text-align: right;
                }
                li.timeActive{
                    font-size:14px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                }
                li.contentActive{
                    font-size:14px;
                    // font-weight:bold;
                    color:rgba(51,51,51,1);
                }
                li.contentActive:before{
                    content: '';
                    display: block;
                    width:10px;
                    height:10px;
                    background-color:rgba(51,51,51,1);
                    border-radius:50%;
                    position: absolute;
                    top: 6px;
                    left: -25px;
                }
                .content_item{
                    font-size:14px;
                    color:rgba(153,153,153,1);
                    line-height: 25px;
                    position: relative;
                    margin-left: 20px;
                    width: 688px;
                }
                .content_item:before{
                    content: '';
                    display: block;
                    width:10px;
                    height:10px;
                    background:rgba(212,212,212,1);
                    border-radius:50%;
                    position: absolute;
                    top: 6px;
                    left: -25px;
                }
                
            }
                
        }
        .news_list:last-of-type{
            border-bottom: none;
        }
    }
    .news_right{
        width: 120px;
        .right_title{
            font-size:14px;
            color:rgba(153,153,153,1);
            line-height: 32px;
        }
        .right_content{
            ul{
                .year{
                    position: relative;
                    line-height: 32px;  
                    font-size:14px;
                    color:rgba(153,153,153,1);
                    padding-left: 26px;
                    cursor: pointer;
                }
                .year:before{
                    position: absolute;
                    content: "";
                    display: block;
                    width: 8px;
                    height: 8px;
                    background:rgba(216,216,216,1);
                    border-radius: 50%;
                    top: 10px;
                    left: 2px;
                }
                .yearActive{
                    font-size:14px;
                    color:rgba(51,51,51,1);
                }
                .yearActive:before{
                    position: absolute;
                    content: "";
                    display: block;
                    width: 8px;
                    height: 8px;
                    background:#111111;
                    border-radius: 50%;
                    top: 10px;
                    left: 2px;
                }
            }
        }
    }    
}
    
</style>